module.exports = __webpack_public_path__ + "static/img/product_society_rule.0f6b9bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_rule.png
// module id = fsk7
// module chunks = 0